import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUser } from "react-icons/fa";
import "../styles/usermenu.css";
import usr_dflt from '../assets/img_usr_default.png';

const UserMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  
  // Alternar el menú
  const toggleMenu = () => setIsOpen(!isOpen);

  // Redirigir y cerrar el menú
  const handleNavigate = (path) => {
    setIsOpen(false);
    navigate(path);
  };

  // Cerrar sesión
  const handleLogout = () => {
    setIsOpen(false);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate('/login');
  };

  return (
    <div className="dropdown">
      {/* Botón del usuario */}
      <button className="dropdown-toggle" onClick={toggleMenu}>
        <img src={usr_dflt} alt="user" className="img_user" />
      </button>

      {/* Menú desplegable con animación */}
      <ul className={`dropdown-menu ${isOpen ? "show" : "hide"}`}>
        <li className="user-info"><FaUser className="user-icon" style={{fontsize: "18px"}}/> {storedUser}</li>
        <li onClick={() => handleNavigate("/cambio_contrasena")}>🔑 Cambiar Contraseña</li>
        <li onClick={() => handleLogout()}>🚪 Cerrar Sesión</li>
      </ul>
    </div>
  );
};

export default UserMenu;
